import appConfig from '@/config/appConfig.typed';
import {ensureGoogleTagManagerInjected} from '@/services/analytics/ga/googleTagManagerBootstrap';

import {notifyOneTrustConsentUpdated} from './oneTrustConsent';

type OneTrustWindow = Window & {
    OptanonWrapper?: () => void;
};

const ONE_TRUST_SCRIPT_ID = 'one-trust-sdk-script';
const ONE_TRUST_SCRIPT_SRC = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

export const ensureOneTrustBannerScriptInjected = () => {
    const oneTrustDomainScriptId = appConfig.getOneTrustDomainScriptId();

    if (!oneTrustDomainScriptId) return;
    if (document.getElementById(ONE_TRUST_SCRIPT_ID)) return;

    const oneTrustScript = document.createElement('script');

    oneTrustScript.id = ONE_TRUST_SCRIPT_ID;
    oneTrustScript.src = ONE_TRUST_SCRIPT_SRC;
    oneTrustScript.type = 'text/javascript';
    oneTrustScript.dataset.documentLanguage = 'true';
    oneTrustScript.dataset.domainScript = oneTrustDomainScriptId;

    const oneTrustWindow = window as OneTrustWindow;

    oneTrustWindow.OptanonWrapper = () => {
        notifyOneTrustConsentUpdated();
        ensureGoogleTagManagerInjected();
    };

    const firstScript = document.getElementsByTagName('script')[0];

    if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(oneTrustScript, firstScript);
        return;
    }

    document.head.appendChild(oneTrustScript);
};
